import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DocumentCriteria } from '../common';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  constructor(private http: HttpClient, private store: Store) { }

  // operator
  async getList(criteria: DocumentCriteria, from = 0, limit = 20) {
    return this.http.post<{ documents: any[], total: number }>(environment.app.apiUrl + 'document/list', { criteria, from, limit }).toPromise();
  }

  isPaid(...id: string[]) {
    return this.http.get<{ [id: string]: boolean }>(environment.app.apiUrl + 'document/ispaid', { params: { id } }).toPromise();
  }

  // operator
  delete(id: string) {
    return this.http.delete(environment.app.apiUrl + 'document/' + id).toPromise();
  }

  // operator
  async save(document: any, file?: File, onprogress?: (progress: number) => void) {
    const formData = new FormData();
    if (file) { formData.append('file', file, file.name); }
    formData.append('document', JSON.stringify(document));
    return new Promise<any>(resolve => {
      this.http.post<any>(environment.app.apiUrl + 'document/save', formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              if (onprogress) { onprogress(Math.round(100 * event.loaded / event.total)); }
              break;
            case HttpEventType.Response:
              resolve(event.body);
              break;
          }
        });
    });
  }

  search(keyword: string, from = 0, limit = 10) {
    return this.http.get<{ documents: any[], total: number }>(environment.app.apiUrl + 'document/search', {
      params: {
        q: keyword || '',
        from: from.toString(),
        limit: limit.toString()
      }
    }).toPromise();
  }

  mine(keyword: string, from = 0, limit = 10) {
    return this.http.get<{ documents: any[], total: number }>(environment.app.apiUrl + 'document/mine', {
      params: {
        q: keyword || '',
        from: from.toString(),
        limit: limit.toString()
      }
    }).toPromise();
  }

  get(id: string) {
    return this.http.get(environment.app.apiUrl + 'document/user/' + id).toPromise();
  }

  // user
  async pay(id: string) {
    const redirect: any = await this.http.get(environment.app.apiUrl + 'document/pay/' + id).toPromise();
    location.href = redirect.link;
  }

  // user
  download(id: string, admin = false) {
    return this.http.get<any>(`${environment.app.apiUrl}document${(admin ? '/admin' : '')}/download/${id}`).toPromise();
  }
}
